module.exports = __webpack_public_path__ + "media/images/plans/plan-wedding-71cb80aa327f3a498efd0cc8544cb115.jpg";